module.exports = __webpack_public_path__ + "assets/dashboard-icon-totalSales.81e27931.svg";